import * as React from 'react'

export const useVisibleOnce = (
	element: React.RefObject<HTMLDivElement | null>,
	rootMargin?: string,
) => {
	const [isVisible, setState] = React.useState(false)

	React.useEffect(() => {
		if (isVisible) return // already latched — no observer needed

		const el = element.current

		// Track intersection state so visibilitychange can latch if tab was hidden
		// when the element first entered the viewport.
		let currentlyIntersecting = false

		const observer = new IntersectionObserver(
			([entry]) => {
				currentlyIntersecting = entry.isIntersecting
				if (entry.isIntersecting && !document.hidden) setState(true)
			},
			{ rootMargin },
		)

		function onVisibilityChange() {
			if (!document.hidden && currentlyIntersecting) setState(true)
		}

		el && observer.observe(el)
		document.addEventListener('visibilitychange', onVisibilityChange)

		return () => {
			el && observer.unobserve(el)
			document.removeEventListener('visibilitychange', onVisibilityChange)
		}
	}, [element, rootMargin, isVisible])

	return isVisible
}
